import type { PriceAlertCondition } from '../types';
import { dollarsToCents } from './format';

export const WHALE_DEFAULT_CENTS = 50_000;

export function getDefaultUsdCents(
  condition: PriceAlertCondition,
  serverDollars: number | null | undefined,
): number {
  if (isWhaleCondition(condition)) return WHALE_DEFAULT_CENTS;
  return dollarsToCents(serverDollars) ?? 0;
}

export function conditionSymbol(condition: PriceAlertCondition): string {
  switch (condition) {
    case 'PRICE_ABOVE':
    case 'VOLUME_24H_ABOVE':
    case 'BOOK_DEPTH_ABOVE':
      return '>';
    case 'PRICE_BELOW':
    case 'VOLUME_24H_BELOW':
    case 'BOOK_DEPTH_BELOW':
      return '<';
    case 'WHALE_TRADE':
      return '≥';
  }
}

export function isVolumeCondition(condition: PriceAlertCondition): boolean {
  return condition === 'VOLUME_24H_ABOVE' || condition === 'VOLUME_24H_BELOW';
}

export function isOpenInterestCondition(condition: PriceAlertCondition): boolean {
  return condition === 'BOOK_DEPTH_ABOVE' || condition === 'BOOK_DEPTH_BELOW';
}

export function isWhaleCondition(condition: PriceAlertCondition): boolean {
  return condition === 'WHALE_TRADE';
}

export function isUsdValueCondition(condition: PriceAlertCondition): boolean {
  return (
    isVolumeCondition(condition) ||
    isOpenInterestCondition(condition) ||
    isWhaleCondition(condition)
  );
}

export function isPriceCondition(condition: PriceAlertCondition): boolean {
  return condition === 'PRICE_ABOVE' || condition === 'PRICE_BELOW';
}
